export default "__VITE_PUBLIC_ASSET__ad6f3faa__"